import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './styles.css'

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean']
  ]
}

const formats = [
  'bold',
  'italic',
  'underline',
  'strike',
  'header',
  'list',
  'bullet',
  'link',
  'image'
]

const RichTextEditor = ({ value, onChange }) => {
  return (
    <ReactQuill
      className='custom-quill-editor'
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
      placeholder='Email Text...'
    />
  )
}

export default RichTextEditor
